function isEqualObjects(obj1, obj2) {
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false
  }
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  if (keys1.length !== keys2.length) {
    return false
  }
  for (let key of keys1) {
    if (!obj2.hasOwnProperty(key)) {
      return false
    }
    if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
      if (!isEqualObjects(obj1[key], obj2[key])) {
        return false
      }
    } else if (obj1[key] !== obj2[key]) {
      return false
    }
  }
  return true
}

function isValidAndNonEmpty(obj) {
  return obj != null && Object.keys(obj).length > 0
}

function filterEmptyContent(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  return Object.fromEntries(
    Object.entries(obj).flatMap(([key, value]) => {
      if (typeof value === 'object' && value !== null) {
        if (
          'content' in value &&
          Array.isArray(value.content) &&
          value.content.length === 0
        ) {
          return []
        }
        const filteredValue = filterEmptyContent(value)
        return Object.keys(filteredValue).length ? [[key, filteredValue]] : []
      }
      return [[key, value]]
    }),
  )
}

export { isEqualObjects, isValidAndNonEmpty, filterEmptyContent }
